import { Controller } from "@hotwired/stimulus"

// Toggles one concat part between a column reference and a literal string. The
// kind <select> shows the matching input (each carries data-kind); switching
// submits the parent mapping form so the part's args persist and the preview
// re-runs.
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.toggle()
  }

  toggle() {
    const kind = this.kindValue
    this.inputTargets.forEach((el) => {
      el.hidden = el.dataset.kind !== kind
    })
  }

  get kindValue() {
    const select = this.element.querySelector("[data-concat-part-kind]")
    return select ? select.value : "column"
  }
}
